<template>
    <div id="react-container">
        <div data-reactroot="">
            <div class="container elegant narrow">
                <!-- 加载状态 -->
                <div v-if="loading" class="loading-wrapper">
                    <div class="loading-spinner"></div>
                    <p>Loading categories...</p>
                </div>

                <!-- 分类列表 -->
                <div v-else class="row">
                    <div class="categories">
                        <span>
                            <div v-for="category in categories" :key="category.id"
                                class="col-md-4 col-sm-6 col-lg-3 category">
                                <router-link :to="`/offers?category=${category.id}`"
                                    style="width: 100%; position: relative; top: 0px; left: 0px; display: inline-block; margin-top: 10px; margin-bottom: 10px; overflow: hidden;">
                                    <span :style="{
                                        display: 'block',
                                        height: '0px',
                                        padding: '0px 0px 100%',
                                        backgroundImage: `url('${getCategoryImage(category)}')`,
                                        transform: 'scale(1)',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: 'center center',
                                        backgroundSize: 'cover',
                                        position: 'relative',
                                        textAlign: 'center',
                                        transition: '0.3s'
                                    }"></span>
                                    <div class="overlay"
                                        style="width: 100%; height: 100%; position: absolute; top: 0px; left: 0px; text-align: center; background: rgba(0, 0, 0, 0.2); transition: 0.3s;">
                                        <h2 class="title">{{ category.name }}</h2>
                                    </div>
                                </router-link>
                            </div>
                        </span>
                    </div>
                </div>

                <!-- 空状态 -->
                <div v-if="!loading && categories.length === 0" class="empty-state">
                    <p>No categories available</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { productApi } from '@/api'

export default {
    data() {
        return {
            loading: false,
            categories: []
        }
    },
    async mounted() {
        await this.loadCategories()
    },
    methods: {
        async loadCategories() {
            try {
                this.loading = true
                const response = await productApi.getProductCate()

                console.log('分类数据响应:', response)

                if (response.code === 1 && response.data) {
                    this.loading = false
                    this.categories = response.data.map(cat => ({
                        id: cat.id,
                        name: cat.name,
                        status: cat.status,
                        image: cat.image || null
                    }))

                    console.log('处理后的分类数据:', this.categories)
                } else {
                    this.loading = false
                    this.$toast('Failed to load categories', 3000)
                }
            } catch (error) {
                console.error('Failed to load categories:', error)
                this.$toast('Failed to load categories, please try again', 3000)
            } finally {
                this.loading = false
                console.log(this.loading);
                
            }
        },
        getCategoryImage(category) {
            // 如果有图片，添加域名前缀
            if (category.image) {
                return category.image.startsWith('http')
                    ? category.image
                    : `https://houtai5698.koiodeal.com${category.image}`
            }
            // 否则使用默认图片
            return this.defaultImages[category.name.toLowerCase()] || this.defaultImages.default
        }
    }
}
</script>
<style scoped>
/* 加载状态 */
.loading-wrapper {
    text-align: center;
    padding: 80px 20px;
}

.loading-spinner {
    width: 50px;
    height: 50px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #000;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 20px;
}

.container {
    min-height: 100vh;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.loading-wrapper p {
    color: #666;
    font-size: 16px;
}

/* 空状态 */
.empty-state {
    text-align: center;
    padding: 80px 20px;
    color: #999;
    font-size: 16px;
}

/* 分类卡片鼠标移入效果 */
.category a:hover span {
    transform: scale(1.1) !important;
}

.category a:hover .overlay {
    background: rgba(0, 0, 0, 0.5) !important;
}

.category a {
    cursor: pointer;
}

.category .overlay {
    transition: background 0.3s ease !important;
}

.category span {
    transition: transform 0.3s ease !important;
}

/* 移动端适配 */
@media (max-width: 767px) {
    .loading-wrapper {
        padding: 60px 20px 80px;
    }

    .empty-state {
        padding: 60px 20px 80px;
    }
}
</style>